export function getActivitiesById(state) {
  return state.admin.activities;
}
